/* eslint-disable sort-imports */
import {
  CHANGE_STATEMENTS_FILTER,
  DOWNLOAD_DOCUMENT_FAILURE,
  DOWNLOAD_DOCUMENT,
  FETCH_DOCUMENTS_HOME_FAILURE,
  FETCH_DOCUMENTS_HOME_SUCCESS,
  FETCH_DOCUMENTS_HOME,
  FETCH_STATEMENT_CANCELLED,
  FETCH_STATEMENT_FAILURE,
  FETCH_STATEMENT_SUCCESS,
  FETCH_STATEMENT,
  FETCH_STATEMENTS_FAILURE,
  FETCH_STATEMENTS_SUCCESS,
  FETCH_STATEMENTS,
  REFRESH_STATEMENTS_URL,
  RESET_ERRORS,
  RESET_STATEMENTS_STATE,
  SET_HOME_LOADING_STEP,
  SET_STATEMENTS_FILE,
  SET_STATEMENTS_PAGES_RENDERED,
  TOGGLE_STATEMENTS_DRAWER,
  UPDATE_REFETCH_STATUS,
} from './constants';

export function changeStatementsFilter(filter) {
  return {
    payload: { filter },
    type: CHANGE_STATEMENTS_FILTER,
  };
}

export function downloadDocument({ fileUrl, modifiedFileName }) {
  return {
    payload: { fileUrl, modifiedFileName },
    type: DOWNLOAD_DOCUMENT,
  };
}

export function downloadDocumentFailure(error) {
  return {
    payload: { error },
    type: DOWNLOAD_DOCUMENT_FAILURE,
  };
}

export function fetchDocumentsHome() {
  return { type: FETCH_DOCUMENTS_HOME };
}

export function fetchDocumentsHomeFailure(error) {
  return {
    payload: { error },
    type: FETCH_DOCUMENTS_HOME_FAILURE,
  };
}

export function fetchDocumentsHomeSuccess({ numPayoff, numStatements }) {
  return {
    payload: { numPayoff, numStatements },
    type: FETCH_DOCUMENTS_HOME_SUCCESS,
  };
}

export function fetchStatement({ statementId, statementUrl }) {
  return {
    payload: { statementId, statementUrl },
    type: FETCH_STATEMENT,
  };
}

export function fetchStatementCancelled() {
  return { type: FETCH_STATEMENT_CANCELLED };
}

export function fetchStatementFailure(error) {
  return {
    payload: { error },
    type: FETCH_STATEMENT_FAILURE,
  };
}

export function fetchStatementSuccess() {
  return { type: FETCH_STATEMENT_SUCCESS };
}

export function fetchStatements() {
  return { type: FETCH_STATEMENTS };
}

export function fetchStatementsFailure(error) {
  return {
    payload: { error },
    type: FETCH_STATEMENTS_FAILURE,
  };
}

export function fetchStatementsSuccess(statements) {
  return {
    payload: { statements },
    type: FETCH_STATEMENTS_SUCCESS,
  };
}

export function refreshStatementsUrl() {
  return { type: REFRESH_STATEMENTS_URL };
}

export function resetErrors() {
  return { type: RESET_ERRORS };
}

export function resetStatementsState() {
  return { type: RESET_STATEMENTS_STATE };
}

export function setHomeLoadingStep(step) {
  return {
    payload: { step },
    type: SET_HOME_LOADING_STEP,
  };
}

export function setStatementsFile(payload) {
  return {
    payload,
    type: SET_STATEMENTS_FILE,
  };
}

export function setStatementsPagesRendered(number) {
  return {
    payload: { number },
    type: SET_STATEMENTS_PAGES_RENDERED,
  };
}

export function toggleStatementsDrawer(drawerState) {
  return {
    payload: { drawerState },
    type: TOGGLE_STATEMENTS_DRAWER,
  };
}

export function updateRefetchStatus(shouldUpdate) {
  return {
    payload: { shouldUpdate },
    type: UPDATE_REFETCH_STATUS,
  };
}
